export default {
  title: 'forgotPassword.title',
  backToLogin: 'general.backToLogin',
  forgotPassword: 'forgotPassword.forgotPassword',
  resetPassword: 'forgotPassword.resetPassword',
  inputLabel1: 'forgotPassword.inputLabel1',
};
